<style lang="stylus">
    .pcstyleModal-mask
        modal-mask()
        z-index 1001

        .pcstyleModal-box
            position absolute
            width 530px
            position fixed
            top 50%
            left 50%
            transform translate(-50%, -50%)
            background-color #fff
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.0982299)
            border-radius 8px

            .pcstyleModal-header
                height 40px
                padding 0 8px 0 12px
                display flex
                align-items center
                user-select none

                &.pcstyleModal-online-header
                    padding 0 8px 0 24px

                    .pcstyleModal-header-text
                        font-weight 700


                .pcstyleModal-header-icon
                    width 16px
                    height 16px
                    margin-right 4px

                .pcstyleModal-header-text
                    font-size 12px
                    color #000

                .pcstyleModal-header-close
                    display flex
                    align-items center
                    justify-content center
                    width 24px
                    height 24px
                    margin-left auto
                    cursor pointer
                    border-radius 6px

                    &:hover
                        background rgba(0,0,0,0.06)

                    svg
                        width 16px
                        height 16px
                        stroke #424242

            .pcstyleModal-content
                padding 24px 22px

        &.dark-theme__pcstyleModal
            .pcstyleModal-box
                background #3F3F41

                .pcstyleModal-header-text
                    color #fff

                .pcstyleModal-header-close
                    svg
                        stroke #DADADF

                .gray-btn
                    background #626365 !important
                    p
                        color #fff !important
</style>
<template>
    <div class="pcstyleModal-mask" :class="{ 'dark-theme__pcstyleModal': isPCDarkMode == 2, noMask: isPC }">
        <div class="pcstyleModal-box" :style="{ width: `${width}px` }">
            <div class="pcstyleModal-header" :class="{ 'pcstyleModal-online-header': !isPC }">
                <div class="pcstyleModal-header-icon" v-if="isPC">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_11412_26856)">
                            <rect width="16" height="16" fill="url(#paint0_linear_11412_26856)" />
                            <path
                                d="M7.99999 8.8125H4.75C4.30127 8.8125 3.9375 8.44873 3.9375 8C3.9375 7.55127 4.30127 7.1875 4.75 7.1875H7.99999C8.44872 7.1875 8.81249 7.55127 8.81249 8C8.81249 8.44873 8.44872 8.8125 7.99999 8.8125Z"
                                fill="white"
                                fill-opacity="0.6"
                            />
                            <path
                                d="M7.99999 4.75H4.75C4.30127 4.75 3.9375 4.38623 3.9375 3.9375C3.9375 3.48877 4.30127 3.125 4.75 3.125H7.99999C10.6924 3.125 12.875 5.30761 12.875 7.99999C12.875 10.6924 10.6924 12.875 7.99999 12.875H4.75C4.30127 12.875 3.9375 12.5112 3.9375 12.0625C3.9375 11.6137 4.30127 11.25 4.75 11.25H7.99999C9.79491 11.25 11.25 9.79491 11.25 7.99999C11.25 6.20507 9.79491 4.75 7.99999 4.75Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_11412_26856"
                                x1="16.7272"
                                y1="18.6666"
                                x2="1.16582"
                                y2="-3.96816"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#0066FF" />
                                <stop offset="1" stop-color="#66CCFF" />
                            </linearGradient>
                            <clipPath id="clip0_11412_26856">
                                <rect width="16" height="16" rx="3.65049" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <span class="pcstyleModal-header-text">{{ title }}</span>
                <div class="pcstyleModal-header-close" @click="close()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3L13 13" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3 13L13 3" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div class="pcstyleModal-content">
                <slot />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class PCStyleModal extends Vue {
        @Prop({
            required: true,
            default: 400,
        })
        width;
        @Prop({
            required: true,
        })
        title;

        close() {
            this.$emit("closeModal");
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
